import wallet_transactions from './wallet_transactions_reducer';

export default {
	wallet_transactions
};
